// https://date-fns.org/docs/format
import format from 'date-fns/format'
import store from '@state/store'
import moment from 'moment'

export function formatDateMoment(date, format) {
  return moment(date)
    .locale(store.getters['auth/language'])
    .format(format)
}

export function formatLongDate(date) {
  const newDate = new Date(date)
  return format(newDate, 'MMMM d, yyyy')
}

export function formatShortDateMonth(date) {
  const newDate = new Date(date)
  return format(newDate, 'MMMM, yyyy')
}

export function formatShortMonth(date) {
  const newDate = new Date(date)
  return format(newDate, 'MMM, yyyy')
}

export function formatShortDateYear(date) {
  const newDate = new Date(date)
  return format(newDate, 'yyyy')
}

export default function formatDate(date) {
  return format(date, 'MMM do, yyyy')
}
